import React from "react";
import { Link } from 'react-router-dom';
import VideoPlayer from "../videoPlayer";

const steps = [
    {
        mp4: 'DOS2.mp4',
        text: "STEP 1 : Open the HUD by clicking on the + sign bottom left and connect your wallet to the D.O.S. The system boots and detects your cypherdudes, select one from the list."
    },
    {
        mp4: 'DOS1.mp4',
        text: "STEP 2 : Activate Flymode by clicking anywhere or hitting the F key, use the mouse and keyboard arrows to move. Fly around till you find a slot you like. Enter it and look toward the cube face with the D.O.S. logo."
    },
    {
        mp4: 'DOS3.mp4',
        text: "STEP 3 : Click on the cube face to claim and confirm the transaction. The slot is soulbound to your cypherdude's token bound wallet. Welcome to the D.O.S. !"
    }
];

function DecentralizedOS() {

    return (
        <div className="ProjectInfo" style={{ paddingBottom: "60px" }}>
            <p className="highlightInfo">DECENTRALIZED OPERATING SYSTEM</p>
            <VideoPlayer src={`${process.env.PUBLIC_URL}/vids/DOS.mp4`} autoPlay={true} loop={true} />
            <div style={{ textAlign: "center" }}>
                <Link to="/dos">
                    <button className="uxBtn">ENTER D.O.S.</button>
                </Link>
            </div>
            <div className="descriptionDiv">
                <p className="starter">The Decentralized Operating System is a monumental space station drifting on the blockchain. A digital haven protected by self-custody where nomad avatars can settle to escape the matrix of corporate-state moguls.</p>
                <p>An open-source, unhosted, code-built infrastructure allowing free interaction, creation, and trade. It is not a written sci-fi novel you can read, nor a dystopian movie you can watch.</p>
                <p>Instead, with the same artistic intent, its written code builds an actual world you can navigate and experiment with, with no storyboard to follow.</p>
            </div>
            <div className="ProjectInfo">
                <p>HOW TO CLAIM YOUR SLOT</p>
                {steps.map((step, id) => {
                    return (
                        <div className="stepRow" key={id}>
                            <VideoPlayer className="stepThumb" src={`${process.env.PUBLIC_URL}/vids/${step.mp4}`} autoPlay={true} loop={true} muted={true} controls={false} />
                            <p className="stepText">{step.text}</p>
                        </div>
                    )
                })}
            </div>
            <div className="ProjectInfo">
                <p>MAIN FEATURES</p>
                <div className="imgGrid">
                    <div className="imgThumb">
                        <VideoPlayer className="Img100" src={`${process.env.PUBLIC_URL}/vids/slot.mp4`} autoPlay={true} loop={true} muted={true} controls={false} />
                        <p className="captionText">THE SLOT : your personal entry point in the D.O.S. memory. While soulbound to your cypherdude, you can still swap against another one to change location. </p>
                    </div>
                    <div className="imgThumb">
                        <VideoPlayer className="Img100" src={`${process.env.PUBLIC_URL}/vids/console.mp4`} autoPlay={true} loop={true} muted={true} controls={false} />
                        <p className="captionText">THE CONSOLE : This is where all tha apps can be launched. Opening cypherdudes, Archives, Palaces, and more. Every action happening in the slot goes through this embedded operating system.</p>
                    </div>
                    <div className="imgThumb">
                        <VideoPlayer className="Img100" src={`${process.env.PUBLIC_URL}/vids/kernel.mp4`} autoPlay={true} loop={true} muted={true} controls={false} />
                        <p className="captionText">THE KERNEL : Located at the center of the D.O.S. it contains 6 portals. For the moment 4 of them are activated and host the Community gallery and the Marketplaces.</p>
                    </div>
                </div>
            </div>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
        </div>
    )
}

export default DecentralizedOS;
